import { useMemo } from 'react'
import moment from 'moment'
import { Text } from '@/ui'
import { CurrencyFormatLabel } from '@/components/CurrencyFormatLabel'
import { centsToDollars } from '@/utils/currencyHelpers'
import { useReselector } from '@/utils/sharedHooks'
import { TypographyStyles } from '@/styles'
import { getProfitAndLossTransaction } from '@/features/transactions/transactions.selectors'

const LineItemTransaction = ({
  transactionId,
  userIdForAdmin,
}: {
  transactionId: number
  userIdForAdmin: number | null
}) => {
  const transaction = useReselector(
    getProfitAndLossTransaction,
    userIdForAdmin,
    transactionId
  )

  const title = useMemo(
    () => (
      <Text variant={TypographyStyles.BODY_SM} className="mr-4">
        {moment.utc(transaction?.date).format('MMM D, YYYY')}
      </Text>
    ),
    [transaction?.date]
  )

  const amount = useMemo(
    () => (
      <Text
        variant={TypographyStyles.BODY_SM}
        className="text-left md:text-end"
      >
        <CurrencyFormatLabel
          value={centsToDollars(transaction?.amountInCents)}
        />
      </Text>
    ),
    [transaction?.amountInCents]
  )

  const description = useMemo(
    () => (
      <Text variant={TypographyStyles.BODY_SM} className="w-full">
        &nbsp;{transaction?.description || 'N/A'}
      </Text>
    ),
    [transaction?.description]
  )

  if (!transaction) return null

  return (
    <div className="flex flex-col md:flex-row flex-wrap border-b border-neutral-200 pb-2">
      <div className="w-full md:w-3/12 text-left">{title}</div>
      <div className="w-full md:w-6/12 text-left">{description}</div>
      <div className="w-full md:w-3/12 text-left">{amount}</div>
    </div>
  )
}

export { LineItemTransaction }
